import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { List, Skeleton } from 'antd';
import './NotificationBoard.css';

import { fetchAllNote, fetchNoteCount, makeReadNote } from '../../api/NotificationRequest';
import { setNoteData, setUnreadNoteCount } from '../../actions/notificationActions';
import { EyeOutlined, EyeInvisibleFilled } from '@ant-design/icons';

import { RiFeedbackLine } from "react-icons/ri";
import { TbRubberStampOff } from "react-icons/tb";
import { AiOutlineNotification } from "react-icons/ai";
import { modalDatumView } from '../../actions/ModalAction';

const NotificationBoard = ({ tab_index }) => {

  const dispatch = useDispatch();
  const location = useLocation();
  const { noteId } = location.state || {};
  const { user } = useSelector((state) => state.authReducer.authData);
  const note_data = useSelector((state) => state.notificationReducer.noteData);
  const [note_arr, setNote_arr] = useState([]);
  const [notes, setNotes] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (noteId) {
      const el = document.getElementById(`note-${noteId}`);
      if (el) el.scrollIntoView({ behavior: 'smooth'});
    }
  }, [noteId, notes])

  const fetchNotes = async () => {
    try {
      const res = await fetchAllNote('all', user._id);
      dispatch(setNoteData(res.data));

      setInitLoading(false); // Set loading to false after fetching
    } catch (error) {
      console.error('Error fetching notes:', error);
      setInitLoading(false); // Also set loading to false in case of error
    }
  };
  const fetchnote = async () => {
    try {

      const unread_note_arr = (await fetchNoteCount(user._id)).data;
      dispatch(setUnreadNoteCount(unread_note_arr));

    } catch (error) {
      console.error('Error fetching announcement:', error);
    }
  };
  useEffect(() => {
    const temp_arr = [];
    if (note_data) {
      temp_arr[0] = note_data;
      for (let i = 1; i <= 5; i++) {
        temp_arr[i] = note_data.filter(note => note.note_type === i);
      }
      setNote_arr(temp_arr);
      setNotes(temp_arr[tab_index]);
    }
  }, [note_data])

  useEffect(() => {
    fetchNotes();
  }, []);

  const iconStyle = (flag) => {
    if (flag === 1) {
      return <AiOutlineNotification />;
    } else if (flag === 3) {
      return <RiFeedbackLine />;
    } else if (flag === 4) {
      return <TbRubberStampOff />;
    } else {
      return null;
    }
  };

  const titleStyle = (flag, title, feedback_obj, note_id) => {

    if (flag === 1) {
      return (<a href="#">{title}</a>);
    } else if (flag === 3 || flag === 4) {
      return (<a href="#" onClick={() => open_datum_modal(feedback_obj, note_id)}>{title}</a>);
    } else {
      return <a href="#">{title}</a>;
    }
  }

  const textStyle = (flag, title, feedback_obj, note_id, note_text) => {

    if (flag === 1) {
      return <div style={{ color: '#000000de' }} dangerouslySetInnerHTML={{ __html: note_text }}></div>;
    } else if (flag === 3 || flag === 4) {
      return <div style={{ color: '#000000de' }} onClick={() => open_datum_modal(feedback_obj, note_id)} dangerouslySetInnerHTML={{ __html: note_text }}></div>;
    } else {
      return <div style={{ color: '#000000de' }} dangerouslySetInnerHTML={{ __html: note_text }}></div>;
    }

  }

  const open_datum_modal = async (feedback_obj) => {
    const noteObject1 = JSON.parse(feedback_obj);
    dispatch(modalDatumView(noteObject1.datumID))
  }

  const changeDate = (time) => {
    const date = new Date(time);
    return (date.toDateString());
  }

  const makeread_note = async (noteid, userid) => {
    let res1;
    await makeReadNote(noteid, userid).then(
      setNotes(prevNotes =>
        prevNotes.map(note =>
          note._id === noteid ? { ...note, read: !note.read } : note
        )
      )
    );
    fetchnote();
  }

  return (
    <div className="notification-board">
      <List
        className="demo-loadmore-list"
        loading={initLoading}
        itemLayout={windowWidth > 700 ? "horizontal" : "vertical"}
        dataSource={notes}
        renderItem={(note) => (
          
          <List.Item id={`note-${note._id}`} >
              <Skeleton avatar title={false} loading={note.loading} active>
                <List.Item.Meta
                  avatar={iconStyle(note.note_type)}
                  title={titleStyle(note.note_type, note.title, note.feedback_obj, note._id)}
                  description={textStyle(note.note_type, note.title, note.feedback_obj, note._id, note.text)}
                />
              </Skeleton>

              
                <div className="actions">
                  {note.read ? (
                    <>
                      <div style={{ color: '#575757de' }}>{changeDate(note.updatedAt)}</div>
                      <EyeOutlined className='read-panel' />
                      <div className='read-padding'>read</div>
                    </>
                  ) : (
                    <>
                      <div style={{ color: '#575757de' }}>{changeDate(note.updatedAt)}</div>
                      <EyeInvisibleFilled className='read-panel' />
                      <a onClick={() => { makeread_note(note._id, user._id) }}>unread</a>
                    </>
                  )}
                </div>
              
          </List.Item>
        )}
      />
    </div>
  );
};

export default NotificationBoard;